import { LayerNames } from '../types/camada.types';

export type NotNull<A> = A extends null | void ? never : A;

export function isAvaliation(layerName: string) {
  return (
    layerName === LayerNames.SAVED_AVALIATIONS_LAYER ||
    layerName === LayerNames.CONSTRUC_AVALIATIONS_LAYER ||
    layerName === LayerNames.TERRAIN_AVALIATIONS_LAYER
  );
}

export function avaliationHasConstructions(f: any) {
  return f.properties.Construído === true || f.properties.Construído === 'true';
}

export function isSample(layerName: string) {
  return (
    layerName === LayerNames.SAMPLE_COLLAB_LAYER ||
    layerName === LayerNames.SAMPLE_LAYER_TERRAIN ||
    layerName === LayerNames.SAMPLE_LAYER_CONSTRUCTIONS
  );
}
